<template>
    <div>
        <v-card>
            <v-card-text>
                <v-container>
                    <v-layout row>
                        <v-btn color="primary" dark @click="addEditDialog = true">New Field</v-btn>
                    </v-layout>
                    <v-layout row>
                        <v-data-table :headers="headers" :items="fields_array" style="width: 100%">
                            <template v-slot:items="props">
                                <td class="text-xs-left">{{ props.item.id }}</td>
                                <td class="text-xs-left">{{ props.item.title }}</td>
                                <td class="text-xs-left">{{ props.item.details }}</td>
                                <td class="text-xs-left">{{ props.item.type }}</td>
                                <td class="text-xs-left">{{ props.item.required ? 'Yes' : 'No' }}</td>
                                <td class="text-xs-center">
                                    <v-btn icon @click="openModal(props.item)" color="primary">
                                        <v-icon>fa-edit</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="deleteField(props.item)" color="red">
                                        <v-icon>fa-trash</v-icon>
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
        <v-dialog v-model="addEditDialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Add/Edit Field</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Title" v-model="field.title" required></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="field.details" label="Details"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-select
                                        v-model="field.type"
                                        :items="['TEXT', 'SELECT', 'MULTISELECT', 'CHECK', 'NUMBER', 'DATE', 'FILE', 'AUDIO']"
                                        label="Select Field Type"
                                >
                                </v-select>
                            </v-flex>
                            <v-flex xs12 v-if="field.type === 'SELECT' || field.type === 'MULTISELECT'">
                                <v-textarea
                                        v-model="field.extra"
                                        label="Select/MultiSelect value"
                                        hint="Each element in line"
                                >
                                </v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <v-checkbox v-model="field.required" label="Required"></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="addEditDialog = false">Close</v-btn>
                    <v-btn color="primary" flat @click="addEditField" :disabled="disable_submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "TicketQuestionForm",
        title: "Ticket Question Form",
        props: {
            question_id: {
                required: true
            },
            fields_array: {
                required: true,
                type: Array
            }
        },
        data() {
            return {
                addEditDialog: false,
                field: {},
                headers: [
                    {text: 'ID', value: 'id'},
                    {text: 'Title', value: 'title'},
                    {text: 'Details', value: 'details'},
                    {text: 'Type', value: 'type'},
                    {text: 'Required', value: 'required'}
                ],
                disable_submit: false
            }
        },
        watch: {
            addEditDialog(val) {
                if (!val && this.field.extra) {
                    this.field.extra = this.field.extra.split('\n');
                }
            }
        },
        methods: {
            addEditField() {
                let data = {...this.field};
                if (data.type === 'SELECT' || data.type === 'MULTISELECT') {
                    data.extra = JSON.stringify(data.extra.split('\n'));
                }
                if (!data.details) {
                    this.field.details = null;
                }
                this.disable_submit = true;
                if (data.id) {
                    this.axios.put(`ticket_question_field/${data.id}`, data)
                        .then(() => {
                            this.field.extra = this.field.extra.split('\n');
                            this.field = {};
                        })
                        .catch(err => console.log(err.message))
                        .finally(() => {
                            this.disable_submit = false;
                            this.addEditDialog = false;
                        });
                } else {
                    data.question_id = this.question_id;
                    this.axios.post('ticket_question_field', data)
                        .then(res => {
                            res.data.data.name = res.data.data.title;
                            this.fields_array.push(res.data.data);
                            this.field = {};
                            this.addEditDialog = false;
                        })
                        .catch(err => {
                            try {
                                if (err.response.data.message) {
                                    window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                                } else {
                                    window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                                }
                            } catch (e) {
                                console.log(err.message, e.message);
                            }
                        })
                        .finally(() => {
                            this.disable_submit = true;
                        });
                }
            },
            openModal(elem) {
                if (elem.type === 'SELECT' || elem.type === 'MULTISELECT') {
                    elem.extra = elem.extra.join('\n');
                }
                this.field = elem;
                this.addEditDialog = true;
            },
        }
    }
</script>

<style scoped>

</style>